export default __webpack_public_path__ + "static/media/schwalmeder_light.13614b11.png";